import { render } from "./System.html?vue&type=template&id=17c26d78&ts=true"
import script from "./System.ts?vue&type=script&lang=ts"
export * from "./System.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__